<div>
  <div [hidden]="shoulHideMenu() ">
    <header class="fixed-menu">
      <app-new-menu (changedLanguage)="changeLanguage($event)" [logoPath]="logoPath"></app-new-menu>
    </header>
  </div>
  <div class="paddingtop" >
    <router-outlet></router-outlet>

  </div>
  <loader [hidden]="isVerficationScreen"></loader>
</div>
